import Subheader from 'components/prism/subheader';
import React, { useState } from 'react';
import ObjectiveList from 'components/prism/objectiveList';
import { SystemText } from 'e4shared';

export const Objectives = ({ profile }) => {
    const [status, setStatus] = useState('outstanding-awaiting');
    const [count, setCount] = useState(0);

    const handleStatusChange = newStatus => {
        setStatus(newStatus);
    };

    const handleDataChange = data => {
        setCount(data?.records || 0);
    };

    const getTitle = () => {
        if (status === 'completed') {
            return SystemText('ObjectiveList/Statuses/Completed');
        }
        return SystemText('ObjectiveList/Statuses/Outstanding');
    };

    if (!profile?.id) return null;

    return (
        <div className="mt20">
            <Subheader title={getTitle()} count={count} />
            <ObjectiveList profileId={profile.id} onStatusChange={handleStatusChange} onDataChange={handleDataChange} />
        </div>
    );
};

export default Objectives;
